// Relative Path: src/js/_header.js

import { gsap } from "gsap";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import lenis from "./_lenis";

gsap.registerPlugin(ScrambleTextPlugin);

class Header {
	constructor() {
		this.header = document.querySelector(".js-header");
		this.btn = this.header.querySelector(".js-btn-menu");
		this.menuContainer = this.header.querySelector(".js-header-menu");
		if (this.menuContainer) {
			this.menuContainer.setAttribute("data-lenis-prevent", "true");
		}

		if (this.header && this.btn) {
			this.init();
			this.initScramble();
		}
	}

	initScramble() {
		const menuLinks = this.header.querySelectorAll(".js-scramble");

		menuLinks.forEach((link) => {
			const container = link.querySelector(".js-text-scramble__text");
			const textSpan = container?.querySelector("span");
			const targetText = container?.dataset.scrambleContent;

			if (!textSpan || !targetText) return;

			const tl = gsap.timeline({ paused: true });

			tl.to(textSpan, {
				scrambleText: {
					text: targetText,
					chars: "lowerCase",
					revealDelay: 0.1,
					speed: 0.4,
				},
				duration: 0.8,
				ease: "power1.out",
			});

			tl.play(0);

			link.addEventListener("mouseenter", () => tl.play(0));
		});
	}

	// toggleMenu = () => {
	// 	const isOpen = this.header.classList.contains("is-open");

	// 	if (isOpen) {
	// 		this.header.classList.remove("is-open");
	// 		this.btn.setAttribute("aria-expanded", "false");
	// 		lenis.start();
	// 	} else {
	// 		this.header.classList.add("is-open");
	// 		this.btn.setAttribute("aria-expanded", "true");
	// 		if (this.menuContainer) this.menuContainer.scrollTop = 0;
	// 		lenis.stop();
	// 	}
	// };

	pagespeed() {
		const container = document.querySelector(".js-ps-orbs");
		if (!container) return;

		const NUM = 5;
		const random = (min, max) => Math.random() * (max - min) + min;

		let orbs = [];
		let bounds = container.getBoundingClientRect();

		const updateBounds = () => {
			bounds = container.getBoundingClientRect();
		};

		const createOrb = () => {
			const el = document.createElement("div");
			el.classList.add("orb");
			container.appendChild(el);

			const size = random(bounds.height * 0.21, bounds.height * 0.89);
			Object.assign(el.style, {
				width: `${size * 0.34}px`,
				height: `${size * 1.44}px`,
			});

			gsap.to(el, {
				"--angle": "360deg",
				duration: random(21, 55),
				repeat: -1,
				ease: "none",
			});

			return {
				el,
				size,
				x: random(0, bounds.width - size),
				y: random(0, bounds.height - size),
				vx: (Math.random() < 0.5 ? -1 : 1) * random(0.34, 0.89),
				vy: 0,
			};
		};

		const update = (o) => {
			o.x += Math.abs(o.vx); // Forza la direzione verso destra

			const offset = bounds.width / 2;
			const maxX = bounds.width + offset; // Fine corsa a destra
			const minX = -o.size - offset;      // Punto di ripartenza a sinistra

			if (o.x >= maxX) {
				o.x = minX; // Reset posizione orizzontale
				o.y = random(0, bounds.height - o.size); // Cambia la Y
			}

			o.el.style.transform = `translate3d(${o.x}px, ${o.y}px, 0)`;
		};

		const init = () => {
			updateBounds();
			container.innerHTML = "";
			orbs = Array.from({ length: NUM }, createOrb);

			gsap.ticker.remove(tick);
			gsap.ticker.add(tick);
		};

		const tick = () => orbs.forEach(update);

		const ro = new ResizeObserver(() => {
			updateBounds();
			orbs.forEach((o) => {
				o.size = random(bounds.height * 0.21, bounds.height * 0.89);
				o.el.style.width = `${o.size * 0.34}px`;
				o.el.style.height = `${o.size * 1.44}px`;
			});
		});

		ro.observe(container);
		init();
	}

	carbon() {
		const container = document.querySelector(".js-cf-orbs");
		if (!container) return;

		const NUM = 5;
		const random = (min, max) => Math.random() * (max - min) + min;

		let orbs = [];
		let bounds = container.getBoundingClientRect();

		const updateBounds = () => {
			bounds = container.getBoundingClientRect();
		};

		const createOrb = () => {
			const el = document.createElement("div");
			el.classList.add("orb");
			container.appendChild(el);

			const size = random(bounds.height * 0.21, bounds.height * 0.89);
			Object.assign(el.style, {
				width: `${size}px`,
				height: `${size}px`,
			});

			gsap.to(el, {
				"--angle": "360deg",
				duration: random(21, 55),
				repeat: -1,
				ease: "none",
			});

			return {
				el,
				size,
				x: random(0, bounds.width - size),
				y: random(0, bounds.height - size),
				vx: Math.cos(Math.random() * Math.PI * 2) * random(0.34, 0.89),
				vy: Math.sin(Math.random() * Math.PI * 2) * random(0.34, 0.89),
			};
		};

		const update = (o) => {
			o.x += o.vx;
			o.y += o.vy;

			const offset = bounds.width / 2;
			const maxX = bounds.width - o.size + offset;
			const maxY = bounds.height - o.size + offset;
			const minX = -offset;
			const minY = -offset;

			if (o.x <= minX || o.x >= maxX) o.vx *= -1;
			if (o.y <= minY || o.y >= maxY) o.vy *= -1;

			o.x = Math.max(minX, Math.min(maxX, o.x));
			o.y = Math.max(minY, Math.min(maxY, o.y));

			o.el.style.transform = `translate3d(${o.x}px, ${o.y}px, 0)`;
		};

		const init = () => {
			updateBounds();
			container.innerHTML = "";
			orbs = Array.from({ length: NUM }, createOrb);

			gsap.ticker.remove(tick);
			gsap.ticker.add(tick);
		};

		const tick = () => orbs.forEach(update);

		const ro = new ResizeObserver(() => {
			updateBounds();
			orbs.forEach((o) => {
				o.size = random(bounds.height * 0.21, bounds.height * 0.89);
				o.el.style.width = `${o.size}px`;
				o.el.style.height = `${o.size}px`;
			});
		});

		ro.observe(container);
		init();
	}

	toggleMenu = () => {
		const isOpen = this.header.classList.contains("is-open");
		isOpen ? this.closeMenu() : this.openMenu();
	};

	openMenu = () => {
		this.header.classList.add("is-open");
		this.btn.setAttribute("aria-expanded", "true");
		if (this.menuContainer) this.menuContainer.scrollTop = 0;
		lenis.stop();

		// Aggiunge listener per chiusura
		document.addEventListener("keydown", this.handleKeyDown);
		document.addEventListener("click", this.handleClickOutside);
	};

	closeMenu = () => {
		this.header.classList.remove("is-open");
		this.btn.setAttribute("aria-expanded", "false");
		lenis.start();

		// Rimuove listener per pulizia
		document.removeEventListener("keydown", this.handleKeyDown);
		document.removeEventListener("click", this.handleClickOutside);
	};

	handleKeyDown = (e) => {
		if (e.key === "Escape") this.closeMenu();
	};

	handleClickOutside = (e) => {
		// Chiude se il click non è dentro l'header o il menu
		if (!this.header.contains(e.target)) {
			this.closeMenu();
		}
	};

	init() {
		this.btn.addEventListener("click", this.toggleMenu);
		this.pagespeed();
		this.carbon();
	}
}

export default Header;
